/*
 * Helper: Global auto-tracking for anchor clicks
 * ---------------------------------------------------------------------------
 * Listens for anchor clicks and pushes standardized GTM events.
 */
import { gtmPush } from './gtm'

/**
 * Check if a URL points to a collection/category page
 * @param {string} href - The URL to check
 * @returns {boolean} True if the URL matches collection or category patterns
 */
function isCollectionHref(href) {
  if (!href) {
    return false
  }
  try {
    const url = new URL(href, window.location.origin)
    return (/\/collections\//).test(url.pathname) || (/\/category\//).test(url.pathname)
  } catch {
    return false
  }
}

/**
 * Initialize global click tracking for navigation and collection links
 * Automatically tracks clicks on header nav, mega menu, and collection links
 * @param {Object} context - Vue component context (passed to gtmPush)
 */
export function initGlobalAutoTrack(context) {
  if (window.gtmAutoTrackInit) {
    return
  }
  window.gtmAutoTrackInit = true

  const handler = (event) => {
    const a = event.target && event.target.closest ? event.target.closest('a') : null
    if (!a) {
      return
    }

    const classList = a.classList || []
    const text = (a.textContent || '').trim()
    const href = a.getAttribute('href') || ''

    if (classList.contains('site-header__navigation-link')) {
      gtmPush(context, 'header_nav_click', text || href, { href })
    }

    if (classList.contains('site-header__misc-navigation-link')) {
      gtmPush(context, 'header_misc_click', text || href, { href })
    }

    if (classList.contains('menu-drawer__link') || a.closest('.menu-drawer')) {
      gtmPush(context, 'megamenu_click', text || href, { href })
    }

    if (isCollectionHref(href)) {
      gtmPush(context, 'collection_link_click', text || href, { href })
    }
  }

  document.addEventListener('click', handler, { capture: true })
}
